/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ServiceResponse
 */
export interface ServiceResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ServiceResponse
     */
    success: boolean;
    /**
     * 
     * @type {string}
     * @memberof ServiceResponse
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceResponse
     */
    westburyId: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceResponse
     */
    recordingId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ServiceResponse
     */
    errors?: Array<string>;
}

/**
 * Check if a given object implements the ServiceResponse interface.
 */
export function instanceOfServiceResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "success" in value;
    isInstance = isInstance && "userId" in value;
    isInstance = isInstance && "westburyId" in value;
    isInstance = isInstance && "recordingId" in value;

    return isInstance;
}

export function ServiceResponseFromJSON(json: any): ServiceResponse {
    return ServiceResponseFromJSONTyped(json, false);
}

export function ServiceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'success': json['success'],
        'userId': json['user_id'],
        'westburyId': json['westbury_id'],
        'recordingId': json['recording_id'],
        'errors': !exists(json, 'errors') ? undefined : json['errors'],
    };
}

export function ServiceResponseToJSON(value?: ServiceResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'success': value.success,
        'user_id': value.userId,
        'westbury_id': value.westburyId,
        'recording_id': value.recordingId,
        'errors': value.errors,
    };
}

